const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
      identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [window.location.origin + '/auth/callback'],
          redirectSignOut: [window.location.origin + '/'],
          responseType: 'code' as const,
          providers: ['Google' as const],
        },
      },
    },
  },
};

const requiredEnvVars = [
  'VITE_USER_POOL_ID',
  'VITE_USER_POOL_CLIENT_ID',
  'VITE_IDENTITY_POOL_ID',
  'VITE_COGNITO_DOMAIN',
  'VITE_API_URL',
  'VITE_REGION'
];

for (const envVar of requiredEnvVars) {
  if (!import.meta.env[envVar]) {
    throw new Error(`Missing required environment variable: ${envVar}`);
  }
}

export default amplifyConfig;
